<template>
    <div class="layout-setting-tabs">
        <div
            v-for="tab in LayoutSettingsTabs"
            :key="tab.value"
            :class="{
                'is--active': tab.value === tabsLocalModel
            }"
            class="layout-setting-nav-tab"
            :tabindex="0"
            @click="onClick(tab.value)"
        >
            {{ tab.label }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { LayoutSettingsTabs } from '@/enum/layout'

const props = defineProps<{
    value?: string
}>()
const emit = defineEmits<{
    (e: 'input', value?: string): void
    (e: 'update:value', value?: string): void
    (e: 'change', value?: string): void
}>()

const tabsLocalModel = useVModel(props, 'value', emit, { eventName: 'input' })

function onClick (tab: string) {
    tabsLocalModel.value = tab
    emit('change', tab)
}
</script>

<style lang="scss">
    .layout-setting-tabs {
        @apply h-full w-full relative flex  flex gap-3 lg:gap-6 text-sm;
        .layout-setting-nav-tab {
            @apply h-full flex items-center border-b-2 border-b-transparent
            cursor-pointer hover:text-primary-actions--focus
                relative -bottom-px pb-px;
            ;
            &.is--active {
                @apply border-b-primary-actions text-primary-actions hover:text-primary-actions--focus;
            }
        }
    }
</style>
